import React from 'react';
import { Box } from '../../../../../Box';
import { dataTableClassnames } from '../../../const/classNames';
import { Checkbox } from './Checkbox';

interface SelectRowCellProps {
  dataTest?: string;
  className?: string;
  onToggle(value?: boolean): void;
  checked: boolean | undefined;
}

export const SelectRowCell: React.FC<SelectRowCellProps> = ({ className, dataTest, checked, onToggle }) => {
  return (
    <Box dataTest={dataTest} className={`${dataTableClassnames.table.cell.selectRow} ${className || ''}`}>
      <Checkbox checked={checked} onToggle={() => onToggle(!checked)} />
    </Box>
  );
};
